import * as React from 'react';

const SVGPrivacyPolicy: React.SFC<SvgProps> = props => (
  <svg width={18} height={20} {...props}>
    <g transform="translate(0 1)" fill="none" fillRule="evenodd">
      <rect
        stroke="#B0BDC0"
        strokeWidth={1.2}
        x={1.1}
        y={5.6}
        width={15.8}
        height={12.8}
        rx={3}
      />
      <path d="M13 4a4 4 0 1 0-8 0" stroke="#B0BDC0" strokeWidth={1.2} />
      <path d="M9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" fill="#B0BDC0" />
    </g>
  </svg>
);

export default SVGPrivacyPolicy;
